import { useCallback } from 'react';
import useCalendarContext from '../CalendarContext';
import moment from 'moment';
import {formatDateToMonthAndYearString} from 'utils/calendar';
import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';

type PreviousMonthPureProps = {
  label: string;
  handlePreviousMonthClick: () => void;
};

const PreviousMonthPure = ({
  label,
  handlePreviousMonthClick,
}: PreviousMonthPureProps): JSX.Element => (
  <div data-testid="previous-month" onClick={handlePreviousMonthClick}>
    {label}
  </div>
);

const PreviousMonth = (): JSX.Element => {
  const { currentDate, handleSelectedDateChange, setCurrentDate } =
    useCalendarContext();
  const isSmallScreen = useSmallDesktopScreen();
  const previousMonthDate = moment(currentDate).subtract(1, 'month');
  const label = formatDateToMonthAndYearString(previousMonthDate);

  const handlePreviousMonthClick = useCallback(() => {
    setCurrentDate(previousMonthDate);

    if (!isSmallScreen) {
      handleSelectedDateChange(previousMonthDate);
    }
  }, [
    isSmallScreen,
    previousMonthDate,
    handleSelectedDateChange,
    setCurrentDate,
  ]);

  return (
    <PreviousMonthPure
      label={label}
      handlePreviousMonthClick={handlePreviousMonthClick}
    />
  );
};

export default PreviousMonth;
